"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarDateDefaultProps = exports.CalendarDate = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _calendar = require("./calendar");

var _CalendarDay = require("./CalendarDay");

var _Icons = require("../../../foundation/Icons");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CalendarDate = function CalendarDate(props) {
  var classNames = props.classNames,
      date = props.date,
      onChange = props.onChange,
      preSelectedDate1 = props.preSelectedDate1,
      preSelectedDate2 = props.preSelectedDate2;

  var _useState = (0, _react.useState)(date),
      _useState2 = _slicedToArray(_useState, 2),
      myDate = _useState2[0],
      setMyDate = _useState2[1];

  var _useState3 = (0, _react.useState)(preSelectedDate1),
      _useState4 = _slicedToArray(_useState3, 2),
      mySelectedDate1 = _useState4[0],
      setSelectedDate1 = _useState4[1];

  var _useState5 = (0, _react.useState)(preSelectedDate2),
      _useState6 = _slicedToArray(_useState5, 2),
      mySelectedDate2 = _useState6[0],
      setSelectedDate2 = _useState6[1];

  var _useState7 = (0, _react.useState)(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      myHoverDate = _useState8[0],
      setHoverDate = _useState8[1];

  var dateClassNames = (0, _classnames.default)({
    'calendar-component__date': true
  }, classNames);
  var dateHeaderClassNames = (0, _classnames.default)('calendar-component__date__header');
  var dateHeaderDaysClassNames = (0, _classnames.default)('calendar-component__date__header', 'calendar-component__date__week');
  var dateHeaderItemClassNames = (0, _classnames.default)('calendar-component__date__header__item', 'calendar-component__date__itementry' // shared with date item.
  );
  var dateWeeklassNames = (0, _classnames.default)('calendar-component__date__week'); // Only send an onChange() event when the date is changed.

  (0, _react.useEffect)(function () {
    if (onChange) {
      onChange(mySelectedDate1, mySelectedDate2);
    }
  }, [onChange, mySelectedDate1, mySelectedDate2]);

  var isDateRestricted = function isDateRestricted(day) {
    var restrictDaysBefore = props.restrictDaysBefore,
        restrictDaysAfter = props.restrictDaysAfter;
    var isBeforeDate = false;
    var isAfterDate = false;

    if (restrictDaysBefore !== undefined) {
      isBeforeDate = (0, _calendar.isBeforeDay)(day, restrictDaysBefore);
    }

    if (restrictDaysAfter !== undefined) {
      isAfterDate = (0, _calendar.isAfterDay)(day, restrictDaysAfter);
    }

    return isBeforeDate || isAfterDate;
  }; // One day was clicked on the displayed month.


  var _onClickDay = function _onClickDay(event, clickedDate) {
    // Nothing selected then one click selects the date.
    if (typeof mySelectedDate1 === 'undefined') {
      setSelectedDate1(clickedDate);
      setSelectedDate2(undefined);
      setHoverDate(undefined); // Day has already been selected as date 1?
    } else if ((0, _calendar.isSameDay)(mySelectedDate1, clickedDate)) {
      // if this date is selected then it needs to be unselected
      if (typeof mySelectedDate2 === 'undefined') {
        // Only date1 selected so unselect date 1
        setSelectedDate1(undefined);
      } else {
        // there is a date 2 (a range selected) - turn off one end of range.
        setSelectedDate1(mySelectedDate2);
        setSelectedDate2(undefined);
      }

      setHoverDate(undefined); // No date 2 selected then use the current selection as date2.
    } else if (typeof mySelectedDate2 === 'undefined') {
      if ((0, _calendar.isBeforeDay)(clickedDate, mySelectedDate1)) {
        setSelectedDate2(mySelectedDate1);
        setSelectedDate1(clickedDate);
      } else {
        setSelectedDate2(clickedDate);
      }

      setHoverDate(undefined); // Day has already been selected as date 2?
    } else if ((0, _calendar.isSameDay)(mySelectedDate2, clickedDate)) {
      setSelectedDate2(undefined);
      setHoverDate(undefined);
    } else if ((0, _calendar.isBeforeDay)(clickedDate, mySelectedDate1)) {
      setSelectedDate2(mySelectedDate1);
      setSelectedDate1(clickedDate);
    } else {
      setSelectedDate2(clickedDate);
    }
  };

  var _onMouseOverDay = function _onMouseOverDay(event, hoverDate) {
    setHoverDate(hoverDate);
  };

  var _onMouseOutDay = function _onMouseOutDay(event, hoverDate) {
    if (typeof myHoverDate !== 'undefined' && (0, _calendar.isSameDay)(hoverDate, myHoverDate)) {
      setHoverDate(undefined);
    }
  }; // User wants to change month showing either plus or minus.


  var _onClickMonthChange = function _onClickMonthChange(monthChange) {
    var newMyDate = new Date(myDate);
    newMyDate.setMonth(newMyDate.getMonth() + monthChange);
    setMyDate(newMyDate);
  }; // Prepare the days for outputting.


  var calendarDays = (0, _react.useMemo)(function () {
    return (0, _calendar.getCalendarDays)(myDate);
  }, [myDate]);
  var displayDays = calendarDays.map(function (x, index) {
    var calDate = new Date(x.year, x.month, x.day);
    var isCurrentMonth = (0, _calendar.isSameMonth)(myDate, calDate);
    var isHover = typeof myHoverDate !== 'undefined' && (0, _calendar.isSameDay)(myHoverDate, calDate);
    var selected = false;
    var partOfRange = false; // We have a start and end date - makes getting the range nice and simple.

    if (typeof mySelectedDate1 !== 'undefined' && typeof mySelectedDate2 !== 'undefined') {
      if ((0, _calendar.isSameDay)(mySelectedDate1, calDate)) {
        partOfRange = 'start';
      } else if ((0, _calendar.isSameDay)(mySelectedDate2, calDate)) {
        partOfRange = 'end';
      } else if ((0, _calendar.isBeforeDay)(mySelectedDate1, calDate) && (0, _calendar.isAfterDay)(mySelectedDate2, calDate)) {
        partOfRange = 'middle';
      } // we only have one date selected, we can make a range using the hover over date value (i.e. range from start date to where pointer is on calendar)

    } else if (typeof mySelectedDate1 !== 'undefined') {
      if ((0, _calendar.isSameDay)(mySelectedDate1, calDate)) {
        selected = true;

        if (typeof myHoverDate !== 'undefined' && (0, _calendar.isAfterDay)(myHoverDate, calDate)) {
          partOfRange = 'start';
        } else if (typeof myHoverDate !== 'undefined' && (0, _calendar.isBeforeDay)(myHoverDate, calDate)) {
          partOfRange = 'end';
        }
      } else if (typeof myHoverDate !== 'undefined') {
        if ((0, _calendar.isSameDay)(myHoverDate, calDate)) {
          partOfRange = 'end';
        } else if ((0, _calendar.isBeforeDay)(mySelectedDate1, calDate) && (0, _calendar.isAfterDay)(myHoverDate, calDate)) {
          partOfRange = 'middle';
        } else if ((0, _calendar.isAfterDay)(mySelectedDate1, calDate) && (0, _calendar.isBeforeDay)(myHoverDate, calDate)) {
          partOfRange = 'middle';
        }
      }
    }

    return /*#__PURE__*/_react.default.createElement(_CalendarDay.CalendarDay, {
      key: index,
      date: calDate,
      inCurrentMonth: isCurrentMonth,
      inHover: isHover,
      onClick: _onClickDay,
      onMouseOver: _onMouseOverDay,
      onMouseOut: _onMouseOutDay,
      selected: selected,
      partofrange: partOfRange,
      onFocus: function onFocus() {},
      onBlur: function onBlur() {},
      disabled: isDateRestricted(calDate)
    });
  }); // Split the days into weeks so we can format properly

  var displayWeeks = [];

  for (var i = 0, j = displayDays.length; i < j; i += _calendar.CALENDAR_DAYS_IN_WEEK) {
    displayWeeks.push(displayDays.slice(i, i + _calendar.CALENDAR_DAYS_IN_WEEK));
  } // ADA compliant - allow an enter key to act like a click.


  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  }; // Finally - output the calendar.


  return /*#__PURE__*/_react.default.createElement("div", {
    className: dateClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-component__date__header-icons-start"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-component__date__header-icon",
    onClick: function onClick() {
      _onClickMonthChange(-12);
    },
    title: "Previous Year",
    role: "button",
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronDoubleLeft, {
    fixedWidth: true
  }), /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronDoubleLeftLight, {
    fixedWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-component__date__header-icon",
    onClick: function onClick() {
      _onClickMonthChange(-1);
    },
    title: "Previous Month",
    role: "button",
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronLeft, {
    fixedWidth: true
  }), /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronLeftLight, {
    fixedWidth: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-component__date__header-month"
  }, "".concat(_calendar.monthNames[myDate.getMonth()], " ").concat(myDate.getFullYear())), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-component__date__header-icons-end"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-component__date__header-icon",
    onClick: function onClick() {
      _onClickMonthChange(1);
    },
    title: "Next Month",
    role: "button",
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronRight, {
    fixedWidth: true
  }), /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronRightLight, {
    fixedWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-component__date__header-icon",
    onClick: function onClick() {
      _onClickMonthChange(12);
    },
    title: "Next Year",
    role: "button",
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronDoubleRight, {
    fixedWidth: true
  }), /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronDoubleRightLight, {
    fixedWidth: true
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderDaysClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderItemClassNames
  }, "S"), /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderItemClassNames
  }, "M"), /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderItemClassNames
  }, "T"), /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderItemClassNames
  }, "W"), /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderItemClassNames
  }, "T"), /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderItemClassNames
  }, "F"), /*#__PURE__*/_react.default.createElement("div", {
    className: dateHeaderItemClassNames
  }, "S")), displayWeeks.map(function (x, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: dateWeeklassNames,
      key: index
    }, x);
  }));
};

exports.CalendarDate = CalendarDate;
CalendarDate.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  preSelectedDate1: _propTypes.default.instanceOf(Date),
  preSelectedDate2: _propTypes.default.instanceOf(Date),
  restrictDaysBefore: _propTypes.default.instanceOf(Date),
  restrictDaysAfter: _propTypes.default.instanceOf(Date),
  date: _propTypes.default.instanceOf(Date).isRequired,
  onChange: _propTypes.default.func.isRequired
};
var CalendarDateDefaultProps = {
  classNames: {}
};
exports.CalendarDateDefaultProps = CalendarDateDefaultProps;
CalendarDate.defaultProps = CalendarDateDefaultProps;
var _default = CalendarDate;
exports.default = _default;